
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import { Component } from "vue-property-decorator";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type CheckBoxMetaData = {
  color?: string;
};

@Component({
  components: {DynamicComponentConfigManager}
})
export default class CheckBoxBase extends BaseDynamicComponent<CheckBoxMetaData> {
  onCheckBoxValueChanged(newValue: boolean): void {
    if (!newValue) {
      newValue = false;
    }
    this.setValueView(newValue);
  }

  public getDefaultValue(): any {
    return false;
  }
}
